import { useEffect, useRef } from "react";
import ActionRow from "../components/v2/ActionRow";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import TextInput from "../components/v2/TextInput";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export const SURFACE_6_LABEL = "Who is this for?";
export const SURFACE_6_PLACEHOLDER = "Their first name";
export const SURFACE_6_ERROR = "We need their name to continue.";

export default function Surface6({
  value,
  error,
  direction = "forward",
  onChange,
  onBlur,
  onBack,
  onNext,
  editMode = false,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const timer = window.setTimeout(() => {
      inputRef.current?.focus();
    }, reduceMotion ? 200 : 360);

    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (error) inputRef.current?.focus();
  }, [error]);

  const nextDisabled = !String(value || "").trim();

  return (
    <section className="tgc-v2-surface" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-content">
          <Wordmark variant="stacked" />
          <QuestionCounter current={2} total={12} />
          <QuestionLabel>{SURFACE_6_LABEL}</QuestionLabel>

          <div className="tgc-v2-field-wrap">
            <TextInput
              ref={inputRef}
              value={value}
              error={error}
              type="text"
              name="recipient_first_name"
              autoComplete="off"
              inputMode="text"
              enterKeyHint="next"
              autoCapitalize="words"
              spellCheck="false"
              maxLength={80}
              placeholder={SURFACE_6_PLACEHOLDER}
              aria-labelledby="question-label"
              aria-describedby={error ? "surface-6-error" : undefined}
              onChange={(event) => onChange(event.target.value)}
              onBlur={onBlur}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  onNext();
                }
              }}
            />
            <div className="tgc-v2-error" id="surface-6-error" aria-live="polite">
              {error ? SURFACE_6_ERROR : ""}
            </div>
          </div>

          <ActionRow
            variant={editMode ? "done-only" : "two-button"}
            onBack={onBack}
            onNext={onNext}
            nextDisabled={nextDisabled}
            nextLabel={editMode ? "Done" : "Next"}
          />
        </div>
      </PageTransition>
    </section>
  );
}
